import { Controller } from "@hotwired/stimulus"

// A flash message that slides in, waits a few seconds, then leaves on its own.
// Dismissable early with the close button. Honours prefers-reduced-motion via
// the element's motion-reduce:transition-none class — the fallback timeout
// still removes it when no transition fires.
export default class extends Controller {
  static values = { delay: { type: Number, default: 4500 } }

  connect() {
    requestAnimationFrame(() => {
      this.element.classList.remove("opacity-0", "translate-y-2")
    })
    this.timer = setTimeout(() => this.close(), this.delayValue)
  }

  disconnect() {
    clearTimeout(this.timer)
  }

  close() {
    clearTimeout(this.timer)
    this.element.classList.add("opacity-0", "translate-y-2")
    const remove = () => this.element.remove()
    this.element.addEventListener("transitionend", remove, { once: true })
    setTimeout(remove, 500) // fallback when no transition runs
  }
}
